import SR_SubTypeComponent from '../../Components/Masters/SR_SubType/SR_SubTypeComponent'

function SR_SubTypePage() {
    return (
        <SR_SubTypeComponent/>
    )
}

export default SR_SubTypePage